import React from 'react';

const SVG = ({
  style = {},
  fill = '#9192a4',
  width = '100%',
  className = '',
  viewBox = '0 0 30 30',
  title = 'Dashboard',
}) => (
  <svg
    fill={fill}
    width={width}
    style={style}
    className={`svg ${className}`}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <style>
        {`
          .svg-dashboard-1 { fill: none; }
          .svg-fill-dashboard-2 { fill: ${fill}; }
        `}
      </style>
    </defs>
    <title>{title}</title>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Isolation_Mode" data-name="Isolation Mode">
        <rect className="svg-dashboard-1" width="30" height="30" />
        <path
          className="svg-fill-dashboard-2"
          d="M25.2,10.49H16.41a.8.8,0,0,0-.8.8V25.2a.8.8,0,0,0,.8.8H25.2a.8.8,0,0,0,.8-.8V11.29A.8.8,0,0,0,25.2,10.49Zm-.48,13.77a.43.43,0,0,1-.43.43h-7a.44.44,0,0,1-.44-.43v-12a.44.44,0,0,1,.44-.44h7a.43.43,0,0,1,.43.44Z"
        />
        <path
          className="svg-fill-dashboard-2"
          d="M25.2,4H16.41a.8.8,0,0,0-.8.8V8.43a.8.8,0,0,0,.8.8H25.2a.8.8,0,0,0,.8-.8V4.8A.8.8,0,0,0,25.2,4Zm-.48,3.48a.43.43,0,0,1-.43.44h-7a.44.44,0,0,1-.44-.44V5.74a.44.44,0,0,1,.44-.43h7a.43.43,0,0,1,.43.43Z"
        />
        <path
          className="svg-fill-dashboard-2"
          d="M13.59,4H4.8a.8.8,0,0,0-.8.8V18.71a.8.8,0,0,0,.8.8h8.79a.79.79,0,0,0,.79-.8V4.8A.79.79,0,0,0,13.59,4Zm-.48,13.76a.44.44,0,0,1-.44.44h-7a.44.44,0,0,1-.43-.44v-12a.43.43,0,0,1,.43-.43h7a.44.44,0,0,1,.44.43Z"
        />
        <path
          className="svg-fill-dashboard-2"
          d="M13.58,20.77H4.81a.81.81,0,0,0-.81.81v3.61a.81.81,0,0,0,.81.81h8.77a.8.8,0,0,0,.8-.81V21.58A.8.8,0,0,0,13.58,20.77Zm-.47,3.48a.45.45,0,0,1-.45.44H5.72a.44.44,0,0,1-.44-.44V22.52a.44.44,0,0,1,.44-.44h6.94a.45.45,0,0,1,.45.44Z"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
